import {
  Colors,
} from '../constants';



export const ArrayColors = {
  arrayDisabled: [
    Colors.grayLight,
    Colors.gray,
  ],


  arrayCancel: [
    Colors.buttonCancel,
    Colors.buttonCancelDark,
  ],


  arrayEdit: [
    Colors.buttonAttention,
    Colors.buttonAttentionAccent,
  ],


  arrayAction: [
    Colors.action,
    Colors.actionDark,
  ],


  arrayOk: [
    Colors.buttonOk,
    Colors.buttonOkDark,
  ],
};



export default ArrayColors;
